import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AdminLayout } from "@/components/AdminLayout";
import { AuthGuard } from "@/components/AuthGuard";

export const Route = createFileRoute("/admin")({
	component: AdminLayoutRoute,
});

function AdminLayoutRoute() {
	return (
		<AuthGuard
			children={
				<AdminLayout>
					<Outlet />
				</AdminLayout>
			}
		/>
	);
}
